// @flow

import registerServiceWorker from './register-service-worker'
import {main, setupSession} from './main'
import {handleError, runApp} from './start'
import getAPIURL from './api-url-util'

// CSS must be loaded in this order
import './assets/css/bootstrap/bootstrap.css'
import './assets/css/flags.css'
import './assets/css/app.css'

async function mainService () {
  const BASE_URL = await getAPIURL(window.location)
  registerServiceWorker()

  await main(window.location, BASE_URL, setupSession)
    .fork(handleError(window.location), runApp(BASE_URL))
}

mainService()



// WEBPACK FOOTER //
// ./src/index.js